import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminService from "../../services/adminService";

export const loginAdmin = createAsyncThunk(
  "admin/loginAdmin",
  async ({ email, password }) => {
    return await adminService.loginAdmin(email, password);
  },
);

export const registerAdmin = createAsyncThunk(
  "admin/registerAdmin",
  async ({ email, password }) => {
    return await adminService.registerAdmin(email, password);
  },
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    adminId: localStorage.getItem("adminId") || null,
    token: localStorage.getItem("adminToken") || null,
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem("adminToken"),
  },
  extraReducers: (builder) => {
    // Login
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.adminId = action.payload.admin_id;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        localStorage.setItem("adminId", action.payload.admin_id);
        localStorage.setItem("adminToken", action.payload.token);
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // Register
    builder
      .addCase(registerAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.adminId = action.payload.admin_id;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        localStorage.setItem("adminId", action.payload.admin_id);
        localStorage.setItem("adminToken", action.payload.token);
      })
      .addCase(registerAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default adminSlice.reducer;
